module.exports = __webpack_public_path__ + "img/half-phantom.a44bee54.png";